import React from "react";

import { useNotificationStack } from "@lib/hooks";

export const NotificationContext = React.createContext({});

export function useNotificationContext() {
  return React.useContext(NotificationContext);
}

export default function NotificationProvider({ children }) {
  const { notifications, addNotification, closeNotification, closeNotificationTimeout } =
    useNotificationStack();

  const contextValue = {
    notifications,
    addNotification,
    closeNotification,
    closeNotificationTimeout,
  };

  return (
    <NotificationContext.Provider value={contextValue}>
      {children}
    </NotificationContext.Provider>
  );
}
